export default __webpack_public_path__ + "static/media/bg-6.3d071a4e.jpg";